import axios from 'axios';

const state = {
  labels: []
};

const getters = {
  getLabels: state => state.labels
};

const actions = {
  loadLabels: ({ commit, getters }) => {
    axios.get(`/api/labels`).then(response => {
      commit('LOAD_LABELS_SUCCESS', response.data);
    });
  }
};

const mutations = {
  ['LOAD_LABELS_SUCCESS']: (state, payload) => {
    state.labels = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
